var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head / 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M452.156 252.907C452.188 254.209 452.205 255.515 452.207 256.825C452.209 257.767 452.209 258.685 452.189 259.629L452.21 259.629L452.257 289.793L452.586 511.447L154.382 511.891L154.006 260.073L154.366 260.072C154.123 256.627 153.997 253.15 153.991 249.644C153.941 215.832 165.15 184.631 184.081 159.591C149.579 150.731 124.056 119.444 124 82.1706C123.934 37.9606 159.72 2.06658 203.932 2.00058C248.142 1.93458 284.036 37.7206 284.102 81.9306C284.112 88.8078 283.255 95.4837 281.634 101.855C288.57 100.855 295.66 100.333 302.871 100.322C385.217 100.198 452.072 166.854 452.195 249.2C452.197 250.439 452.184 251.675 452.156 252.907Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M301.871 249.216C304.329 249.989 306.866 250.65 309.471 251.191C311.581 251.641 313.727 252.001 315.929 252.271C319.463 252.743 323.107 252.965 326.807 252.959C350.273 252.924 370.749 243.453 381.712 229.396C382.288 231.636 382.951 233.84 383.697 236.002C384.101 237.102 384.507 238.244 384.975 239.342C387.913 246.74 391.827 253.596 396.547 259.712C403.126 268.221 411.283 275.308 420.545 280.478C416.386 310.226 406.188 350.234 382.203 366.192C369.003 374.972 345.003 376.052 324.563 374.872L319.863 432.952C319.863 432.952 286.683 418.472 267.683 407.752C264.403 405.912 261.563 404.172 259.383 402.632C259.743 399.212 260.563 391.252 261.603 381.312V381.272C263.483 363.372 266.043 339.032 267.723 322.992C256.523 306.012 226.023 302.192 225.983 278.312C225.983 271.152 230.163 258.772 245.603 258.752C266.323 258.712 263.383 283.552 263.383 283.552C275.12 288.122 289.103 270.34 301.871 249.216Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.785 291.005L395.585 326.885L378.415 326.541L380.785 291.005Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.029 292.56C364.659 299.728 360.445 305.312 355.613 305.034C350.781 304.756 347.163 298.72 347.531 291.552C347.901 284.384 352.115 278.798 356.947 279.078C361.779 279.356 365.397 285.392 365.029 292.56Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.402 291.416C410.032 298.582 405.818 304.168 400.986 303.89C396.154 303.612 392.536 297.574 392.904 290.408C393.274 283.24 397.488 277.654 402.32 277.932C407.152 278.21 410.77 284.248 410.402 291.416Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M374.202 343.727C374.202 343.727 363.014 347.339 351.804 334.873",
    stroke: "#1C295E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    opacity: 0.401344,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.555 374.866C324.555 374.866 298.695 375.63 287.671 369.608L323.181 391.904L324.555 374.866Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead8);
export default __webpack_public_path__ + "static/media/Girl-Head-8.7a45ce78.svg";
export { ForwardRef as ReactComponent };